import React from "react";
import {useLocation} from 'react-router-dom'
import { Layout } from 'antd';
import AuthorizeMail from "./components/AuthorizeMail"

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AuthorizeMailPage = () => {
  const query = useQuery();
  return (
    <Layout>
      <AuthorizeMail token={query.get('token')} />
    </Layout>
  )
}

export default AuthorizeMailPage;
